var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"px-1 m-auto md:pt-2-half container-xs"},[_c('a',{staticClass:"button block text-center mt-2 primary",attrs:{"href":_vm.redirectLink}},[_vm._v("Return to the App")])])}
var staticRenderFns = []

export { render, staticRenderFns }